import { tao } from '../nativeTokens';

import { ChainId } from '../../types';

export const bittensorEvm = [tao[ChainId.BITTENSOR_MAINNET]];
